import React, { PureComponent } from 'react';
import MainPerformance from '../tables/MainPerformance';
import CrcPerformance from '../tables/CrcPerformance';
import PersonInfo from '../tables/PersonInfo';
import QualityEvaluation from '../tables/QualityEvaluation';
import Feedback from '../tables/Feedback';

class MainContent extends PureComponent {
    render() {
        const { loading, restData, date } = this.props;
        const { performanceScores, studentAchievementList, studentInfoList, pmCrcScoreList } = restData;
        return (
            <div>
                <MainPerformance loading={loading} data={performanceScores} />
                <CrcPerformance loading={loading} data={studentAchievementList} />
                <PersonInfo loading={loading} data={studentInfoList} />
                <QualityEvaluation loading={loading} data={studentInfoList} />
                <Feedback loading={loading} data={pmCrcScoreList} date={date} />
            </div>
        );
    }
}

export default MainContent;



// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/components/MainContent.js